<template>
  <v-form @submit.prevent="submit">
    <v-text-field
      v-model="room.name"
      label="Nome"
      :loading="loading"
      :error-messages="error.name || ''"
      required
    ></v-text-field>
    <autocomplete
      v-model="room.hotel"
      :error-messages="error.hotel"
      :model="hotelModel"
      item-text="name"
      item-value="id"
      label="Hotel"
      chips
    ></autocomplete>
    <v-text-field
      v-model="room.capacity"
      label="Capacità"
      :loading="loading"
      :error-messages="error.capacity || ''"
      required
    ></v-text-field>
    <form-actions :loading="loading" @undo="reset" @submit="submit" />
  </v-form>
</template>

<script>
import { cloneDeep } from "@/lodash"

import models from "@/models"

export default {
  props: {
    withData: {
      type: Object,
      default: () => ({}),
    },
    error: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      room: {},
      hotelModel: models.Hotel,
    }
  },
  watch: {
    withData: {
      handler: "reset",
      deep: true,
    },
  },
  methods: {
    reset() {
      this.room = cloneDeep(this.withData)
    },
    submit() {
      this.$emit("submit", this.room)
    },
  },
}
</script>
